/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { VehicleScheduleBase } from './VehicleScheduleBase';
export type VehicleSchedulePrivate = (VehicleScheduleBase & {
    type?: VehicleSchedulePrivate.type;
});
export namespace VehicleSchedulePrivate {
    export enum type {
        PRIVATE = 'private',
    }
}

